
export type NotificationListResponseNotificationsItemBasicInfoType = typeof NotificationListResponseNotificationsItemBasicInfoType[keyof typeof NotificationListResponseNotificationsItemBasicInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationListResponseNotificationsItemBasicInfoType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
